import React from 'react';
import CacheBuster from 'react-cache-buster';
import { version } from '../package.json';

import { ThemeProvider } from '@material-ui/core/styles';

import AppRouter from './components/AppRouter';
import { AuthContextProvider } from './context/authContext';
import { InitContextProvider } from './context/initContext';
import { MerchantContextProvider } from './context/merchantContext';
import { NavContextProvider } from './context/navContext';
import { DeepLinkContextProvider } from './context/deepLinkContext';
import { StampCardContextProvider } from './context/stampCardContext';
import { MsgContextProvider } from './context/messageContext';
import { PWAContextProvider } from './context/pwaContext';
import { useGoogleMapsApi } from './hooks/useGoogleMapsApi';
import { GoogleOAuthProvider } from '@react-oauth/google';
import theme from './styles/theme';

const GOOGLE_API_KEY = process.env.REACT_APP_GOOGLE_API_KEY as string;
const googleWebClient = process.env.REACT_APP_GOOGLE_OAUTH_WEB_CLIENT as string;

function App() {
  useGoogleMapsApi(GOOGLE_API_KEY);

  return (
    <CacheBuster currentVersion={version} isEnabled={true}>
      <ThemeProvider theme={theme}>
        <AuthContextProvider>
          <GoogleOAuthProvider clientId={googleWebClient}>
            <NavContextProvider>
              <MerchantContextProvider>
                <DeepLinkContextProvider>
                  <StampCardContextProvider>
                    <MsgContextProvider>
                      <InitContextProvider>
                        <PWAContextProvider>
                          <AppRouter />
                        </PWAContextProvider>
                      </InitContextProvider>
                    </MsgContextProvider>
                  </StampCardContextProvider>
                </DeepLinkContextProvider>
              </MerchantContextProvider>
            </NavContextProvider>
          </GoogleOAuthProvider>
        </AuthContextProvider>
      </ThemeProvider>
    </CacheBuster>
  );
}

export default App;
